/**
 * How a room Elara picked says so on its card, wherever the card is drawn — the hotel guide's Find rooms
 * grid and the chat carousel: the curated tag as an accent badge on the photo (`RoomCard`'s `coverBadge`)
 * and the reason above the price (its `note`). Both read the pick's `recommendation`, which the room
 * search writes on the picked rate; price that card on the same rate, so the reason and the price agree.
 */
import type { RoomRate } from '@elara/domain/models/schemas/room-schemas';

import { roomPickLabel } from '@elara/client-core/lib/room-utils';

import { Badge } from '#ui/badge.js';

type RoomPickRecommendation = NonNullable<RoomRate['recommendation']>;

/**
 * Why the room is in the set, for the photo's top-left corner: the curation agent's badge for this trip
 * ("Most space", "Best for kids") when it wrote one, else the kind of pick ("Best room", "Lowest price").
 * Nothing for a plain suggestion, which every presented room already is (`roomPickLabel`).
 */
export function RoomPickBadge({ recommendation }: { recommendation: RoomPickRecommendation }) {
  const label = roomPickLabel(recommendation);
  if (!label) return null;
  return (
    <Badge variant="affiliate" className="shadow-sm">
      {label}
    </Badge>
  );
}

/** Why Elara picked the room, in full, at regular weight whatever the card around it sets. */
export function RoomPickReason({ recommendation }: { recommendation: RoomPickRecommendation }) {
  return <p className="m-0 text-sm font-normal text-pretty text-foreground">{recommendation.reason}</p>;
}
